module.exports = __webpack_public_path__ + "img/smiling_face_with_sunglasses.a3a17625.gif";